export default __webpack_public_path__ + "static/pma-9a5a807eb470d3f3e9544043b80111bf.png";